
import { toString } from "../fable_modules/fable-library-js.5.3.0/Date.js";
import { create } from "../fable_modules/fable-library-js.5.3.0/DateOnly.js";
import { item } from "../fable_modules/fable-library-js.5.3.0/Array.js";

export function monthDay(timezone, instant) {
    return (function(i,z){try{return new Date(i).toLocaleDateString('en-US',{month:'short',day:'numeric',timeZone:z})}catch(e){return new Date(i).toLocaleDateString('en-US',{month:'short',day:'numeric',timeZone:'UTC'})}})(toString(instant, "o"),timezone);
}

/**
 * The calendar day `instant` falls on in `timezone`.
 */
export function localDay(timezone, instant) {
    const ymd = (function(i,z){function p(tz){var parts=new Intl.DateTimeFormat('en-US',{timeZone:tz,year:'numeric',month:'numeric',day:'numeric'}).formatToParts(new Date(i));var g=function(t){return parseInt(parts.find(function(x){return x.type===t}).value,10)};return [g('year'),g('month'),g('day')]}try{return p(z)}catch(e){return p('UTC')}})(toString(instant, "o"),timezone);
    return create(item(0, ymd), item(1, ymd), item(2, ymd));
}

//# sourceMappingURL=ZonedDate.js.map
